import React, { useEffect, useState } from 'react'
import { Col, Form, Row } from "react-bootstrap";
import SubmitButton from "../Main/Dashboard/components/SubmitButton";
import { useNavigate, useParams } from "react-router-dom";
import columnConfig from "../Main/Dashboard/columns";
import { Api } from "../../../helpers/Api";
import "react-datepicker/dist/react-datepicker.css";
import { Validation } from "../../../helpers/Validation";
import { connect } from "react-redux";
import { renderField } from "../Main/Form/form";

const Report = ({ user, ...props }) => {
    const params = useParams();
    const [data, setData] = useState({ students: [{ name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }], news: [{ url: "" }] });

    if (params.type == 'New-IIC') {
        params.type = 'IIC';
        params.change = true;
        params.path = 'NewIicReport';
    } else if (params?.change != true) {
        params.path = 'Report';
    }

    let config = columnConfig[params.path];
    const navigate = useNavigate();
    const [state, setState] = useState({
        loading: false,
        error: null,
        config: config,
        page: 1,
        limit: 20000,
        total: 0,
        show: false,
    });
    const [errors, setErrors] = useState({});

    // Add More Field
    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const d = { ...data };
        d.resource_persons[index][name] = value;
        setData(d)
    };

    const handelVerification = () => {
        alert(`Are you sure`);
        Api.call(`/verifyReport/${data?.id}`)
            .then((getdata) => {
                let d = { ...data };
                d.Verified = !d.Verified;
                setData(d);
                alert(`${getdata.message}`);
            }).catch((error) => {
                alert(`${error.message}`);
            }).finally(() => {
                console.log(`Done`);
            });
    }

    const fetchOptions = async (c) => {
        let o = await Api.call(`${c.url}`);
        let options = [];
        if (c.url != "/departments") {
            options.push({ label: "Please Select", value: "" })
        }
        o.map(object => {
            options.push({ label: object[c.label], value: object[c.key], object });
        })
        return options;
    }

    useEffect(async () => {
        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].updateOptions) {
                config.form[i].options = config.form[i].updateOptions(config.form[i].allOptions, data);
            }
        }
    });

    useEffect(async () => {
        const config = { ...state.config };

        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].updateOptions) {
                config.form[i].options = config.form[i].updateOptions(config.form[i].allOptions, data);
            }
        }
        setState((s) => {
            return { ...s, config }
        })
    }, [data])

    useEffect(async () => {
        if (!user) {
            return;
        }
        for (let i = 0; i < config.form.length; i++) {
            if (config.form[i].fetchOptions) {
                let options = await fetchOptions(config.form[i].fetchOptions);
                if (!config.form[i].updateOptions) {
                    config.form[i].options = options;
                }
                config.form[i].allOptions = options;
            }
        }
        setState((s) => {
            return { ...s, config }
        })
    }, [config, user]);

    const loadData = (id) => {
        if (id == 'new') {
            Api.call(`/reports?template=${params.eventId}`).then(post => {
                let res = null;
                if (post && post[0]) {
                    res = { ...post[0], Verified: false, Description: null, objective: null, oActivity: null, outcomes: null, eventWith: params.type, template: params.eventId }
                }
                if (res) {
                    if (!res['students']) res["students"] = [{ name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }];
                }
                else {
                    res = { eventWith: params.type, template: params.eventId };
                    res["students"] = [{ name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }];
                }
                res['OrganizingTeamDetails'] = [{ Name: "",Designation:"", Department: "", Role: ""}];
                res['speakerDetails'] = [{ Name: "", Designation: "", Organization: "", Brief: "" }];
                setData(res);
            }).catch(console.log).finally(() => {
                updateState({ loading: false });
            });
            setData(data);
            return;
        }
        Api.call(`/reports/${id}`).then(post => {
            let res = { ...post }
            if (!res['students']) res["students"] = [{ name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }, { name: '', email: '' }];
            if (!res["eventWith"]) res["eventWith"] = "Common";
            setData(res);
            setTimeout(() => {
                // console.log(data);
            }, 2000)
        }).catch(console.log).finally(() => {
            updateState({ loading: false });
        });

    };

    useEffect(() => {
        if (params.id) {
            loadData(params.id)
        }

    }, [params.eventId])

    useEffect(()=>{
        console.log(data);
    },[data])

    const validate = () => {
        let errors = {};
        state.config.form.map((field) => {
            if (field.condition && data[field.condition.key] !== field.condition.value) {
                return;
            }
            if (field.required && !data[field.key]) {
                errors[field.key] = `${field.name} is required`;
            }
            if(field?.size){
                if (data[field.key] && data[field.key].split(' ').length > field.size) {
                    errors[field.key] = `${field.name} is too large`;
                }
            }
            if (field.validations) {
                let validate;

                if (field.validations[0].compareWith) {
                    validate = Validation.Ragularexpression(data[field.key], field.validations, data[field.validations[0].compareWith])
                }
                else {
                    validate = Validation.Ragularexpression(data[field.key], field.validations)
                }
                if (validate && validate[0]) {
                    let a = Validation.Ragularexpression(data[field.key], field.validations);
                    errors[field.key] = `${a[0]}`;
                }

            }
        });
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const submit = (e) => {
        e.preventDefault();
        if (!validate()) {
            if (!data["EventsPhotos"]) {
                alert("Photo was not Uploaded");
            }
            return;
        }

        if (params.id != 'new') {
            update();
        } else {
            if (data["EventsPhotos"].length < 6) {
                alert("Min photo should be 6");
                return;
            }
            create();
        }
        alert("Report Details has been saved, You can download report now");
        navigate(`/templateReports/${params.eventId}`);
    };

    const updateState = (obj) => {
        setState(s => {
            Object.keys(obj).forEach(key => {
                s[key] = obj[key];
            });
            return s;
        });
    }
    useEffect(() => {
        if (params.id) {
            loadData(params.id)
        }

    }, [params.id])

    const update = () => {
        updateState({ loading: true });
        Api.call(`/reports/${data.id}`, "PUT", data).then(post => {
            setData(post)
        }).catch(console.log).finally(() => {
            updateState({ loading: false });
        })
    };

    const create = () => {
        updateState({ loading: true });
        Api.call(`/reports`, "POST", {...data,newIic: params?.change !== true ? false : true }).then(post => {
            setData(post);
        }).catch(console.log).finally(() => {
            updateState({ loading: false });
        })
    };

    // Add More Field
    // handle input change
    const handleChange = (e, index,type) => {
        const { name, value } = e.target;
        const d = { ...data };
        d[type][index][name] = value;
        console.log("data changes:",d);
        setData(d)
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index,type) => {
        const d = { ...data };
        d[type].splice(index, 1);
        setData(d)
    };

    // handle click event of the Add button
    const handleAddClick = (type) => {
        const d = { ...data };
        if(type == 'speakerDetails'){
            d[type].push({ Name: "", Designation: "", Organization: "", Brief: "" });
        }else{
            d[type].push({ Name: "",Designation:"", Department: "", Role: ""});
        }
        setData(d)
    };

    const onChange = (key, value, index = null, size, type = null) => {

        if (type == "rowTextarea") {
            let d = { ...data };
            if (d[key] && d[key].split(' ').length > size) {
                setErrors(errors);
                return;
            }
            let errors = {};
            setErrors(errors);
            let arrayString = value?.split(' ');
            if (arrayString.length > size) {

                errors[key] = `Only ${size} words allowed`;
                setErrors(errors);
                return;
            }
            d[key] = value;
            setData(d)
            return;
        }
        else {
            if (key == "multi") {
                let d = { ...data };
                Object?.keys(value).map(keyy => {
                    d[keyy] = value[keyy]
                });
                setData(d)
                return;
            }
            if (index !== null) {
                let d = { ...data };
                d[key][index].url = value;
                setData(d)
                return;
            }

            else {
                let d = { ...data };
                d[key] = value;
                setData(d)
                return;
            }
        }
    };

    const Delete = () => {
        let d = { ...data };
        d.Attendence = null;
        setData(d);
    }

    const onTesyChange = (key, value, index = null) => {
        let d = { ...data };
        d["students"][index][key] = value;
        setData(d)
        return;
    }


    return <div className="right_container">
        <div className="dashboard">
            <div className='inner-content'>
                <div className="reports-header">
                    <div><h4>Report</h4></div>
                    <div><a className='btn btn-secondary btn-sm' target='_blank' href={`https://eventscu.s3.ap-south-1.amazonaws.com/Required_Report_IIC_442ecdc0a3.pdf`} >IIC Format(from 01/July/2026)</a>
                        <a className='btn btn-secondary btn-sm' target='_blank' href={`${Api.base_url1}/uploads/Standard_Format_IIC_Activity_WEF_01_September_2022_c4d31c7c37.docx`} style={{ marginLeft: 20}}>IIC Format (Till 30/June/2026)</a>
                        <a className='btn btn-secondary btn-sm' target='_blank' href={`${Api.base_url1}/uploads/Guidelines_for_RISE_Events_1_0_5_ebe3ac73a6.docx`} style={{ marginLeft: 20, marginRight: 10 }}>RISE-EVENT Format Guidelines</a>
                    </div></div>
                <div className='mt-3 commen-form'>
                    {state.config.renderForm ?
                        state.config.renderForm() :
                        <Form autoComplete={'off'} onSubmit={submit}>
                            <Row>
                                {state.config.form.map((field) => {
                                    if (field.render) {
                                        let d = data[field.key];
                                        if (!d) {
                                            d = [];
                                        }
                                        return field.render(data, onChange, d, (d) => {
                                            onChange(field.key, d)
                                        })
                                    }
                                    else if (field.type == "addMoreOption") {
                                        return renderField(field, errors, data, onChange, null, Delete,handleChange,handleRemoveClick,handleAddClick)
                                    }
                                    else if (field.key == "Attendence") {
                                        return renderField(field, errors, data, onChange, null, Delete)
                                    }
                                    return renderField(field, errors, data, onChange)
                                })}
                            </Row>
                            {data["eventWith"] == "RISE-Event" && <h2>Testimonial Details</h2>}
                            {data["eventWith"] == "RISE-Event" && data?.students?.map((field, index) => {
                                return <Row>
                                    <Col md={6}><Form.Group >
                                        <Form.Label>Statement of Testimonial*</Form.Label>
                                        <Form.Control className={errors[field.key] ? 'error-field' : ''} type="text" value={field.name}
                                            onChange={event => onTesyChange("name", event.target.value, index)}
                                            placeholder="" disabled={field?.disabled} required />
                                    </Form.Group>
                                    </Col>
                                    <Col md={6}><Form.Group >
                                        <Form.Label>Testimonial Email*</Form.Label>
                                        <Form.Control className={errors[field.key] ? 'error-field' : ''} type="text" value={field.email}
                                            onChange={event => onTesyChange("email", event.target.value, index)}
                                            placeholder="" disabled={field?.disabled} required />
                                    </Form.Group>
                                    </Col>
                                </Row>

                            })}
                            <div className='mt-3 Form-buttons'>
                                {(user?.user?.role === 1 || user?.user?.role === 3) && <button type="button" onClick={handelVerification} className='cancel'>
                                    {data['Verified'] ? "Unverified Report" : "Verified Report"}</button>}
                                <button type="button" onClick={() => {
                                    navigate(`/${state.config.cancel_url}`)
                                }} className='cancel'>Cancel</button>
                                <SubmitButton label='Submit'
                                    loading={state.loading} />
                            </div>
                        </Form>
                    }
                </div>
            </div>
        </div>
    </div>
}


const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Report)